<template>
  <form>
    <DodBorderSection>
      <template v-slot:section-slot>
        <DodAddUserForm
          title="Dane podopiecznego"
          :errorsObj="errorsObject"
          :prePick="customerData"
          :withSocialWorkerPhone="true"
          :withRegion="true"
          @userDataChange="(e) => (customerData = e)"
        />
        <DodAddUserForm
          v-if="isClientDataActive"
          title="Dane klienta"
          :isClient="true"
          :prePick="clientData"
          :errorsObj="errorsObject"
          @userDataChange="(e) => (clientData = e)"
        />
        <div style="width: 33%">
          <DodCustomAddButton
            :underlined="isClientDataActive"
            :removePlus="isClientDataActive"
            :title="`${
              isClientDataActive ? 'Usuń dane klienta' : 'Dodaj dane klienta'
            }`"
            @click="isClientDataActive = !isClientDataActive"
          />
        </div>
      </template>
    </DodBorderSection>
    <DodBorderSection>
      <template v-slot:section-slot>
        <div class="flex" style="align-items: center; padding: 0">
          <DodCustomDateInput
            title="START OPIEKI"
            placeholder="Start opieki"
            :isRequired="true"
            :prePick="startDate"
            :maxDate="endDate"
            style="margin-bottom: 35px"
            :errorMsg="errorsObject ? errorsObject.careStartDate : ''"
            @dateChange="(e) => (startDate = e)"
          />
          <DodCustomDateInput
            title="KONIEC OPIEKI"
            placeholder="Koniec opieki"
            :isRequired="false"
            :prePick="endDate"
            :minDate="startDate"
            style="margin-bottom: 35px"
            @dateChange="(e) => (endDate = e)"
          />
          <PrimaryInput
            title="ODPŁATNOŚĆ"
            placeholder="Kwota za godzinę opieki"
            :grayInput="true"
            :isRequired="false"
            :type="'number'"
            :min="0"
            :value="price"
            style="margin-bottom: 35px"
            :errorMsg="errorsObject ? errorsObject.payment : ''"
            @change="(e) => (price = e)"
          />
          <div
            v-if="scopesOfCares && scopesOfCares.length > 0"
            style="margin-bottom: 35px"
          >
            <p class="input-label">ZAKRES OPIEKI</p>
            <custom-select
              :options="scopesOfCares"
              :default-value="'Zakres opieki'"
              :graySelect="true"
              :prePick="careOption"
              :isMultiple="true"
              title="ZAKRES OPIEKI"
              @newPick="(e) => (careOption = e)"
            />
          </div>
        </div>
        <DodCustomTextarea
          v-if="isNonStandardRange"
          title="NIESTANDARDOWY ZAKRES"
          placeholder="Niestandardowy zakres usług opiekuńczych"
          :prePick="nonStandardRangeText"
          @change="(e) => (nonStandardRangeText = e)"
        />
        <div style="width: 33%">
          <DodCustomAddButton
            :underlined="isNonStandardRange"
            :removePlus="isNonStandardRange"
            :title="`${
              isNonStandardRange
                ? 'Usuń niestandardowy zakres'
                : 'Dodaj niestandardowy zakres'
            }`"
            @click="isNonStandardRange = !isNonStandardRange"
          />
        </div>
      </template>
    </DodBorderSection>
    <DodCustomTextarea
      title="KONTAKT"
      placeholder="Osoby wyznaczone do kontaktu"
      :prePick="contact"
      @change="(e) => (contact = e)"
      style="margin-top: 20px"
    />
    <label for="documentFile" style="display: block">
      <div
        class="flex"
        style="align-items: center; justify-content: space-between"
      >
        <p class="input-label" style="font-size: 14px">
          ZAŁĄCZNIKI (UMOWA, DECYZJA)
        </p>
        <img src="../../icons/dod/dodAddPlusIcon.svg" alt="Plus" />
      </div>
      <div class="dashed-square">
        <img src="../../icons/dod/dodDownloadIcon.svg" alt="Download" />
        <input
          type="file"
          id="documentFile"
          style="display: none"
          @change="handleAddFile"
          multiple
        />
      </div>
      <div
        v-if="
          (fileInput && fileInput.length) || filesFetchedFromCustomer.length
        "
        style="margin-left: 10px"
        class="p-0"
      >
        <p v-for="(file, index) in fileInput" :key="index">
          <span>{{ `${file.name} ` }}</span>
          <span
            class="remove-file"
            @click="(e) => handleRemoveFile(e, file.name)"
            >X</span
          >
        </p>
        <p v-for="file in filesFetchedFromCustomer" :key="file.id">
          <span>{{ `${file.originalName} ` }}</span>
          <span
            class="remove-file"
            @click="(e) => handleRemoveExistingFile(e, file)"
            >X</span
          >
        </p>
      </div>
    </label>
    <custom-button
      :disabled="loading"
      style="margin-left: auto"
      :title="customer ? 'Edytuj' : 'Dodaj'"
      gradient="true"
      custom-styles="border-radius: 50px"
      @click="onSubmit"
    />
    <dod-duplicate-found-modal
      v-if="duplicate"
      :type="'customer'"
      :person="duplicate"
      @back="duplicate = null"
      @goToProfile="openDuplicateProfile"
    />
  </form>
</template>

<script>
import DodBorderSection from "./DodBorderSection";
import DodCustomAddButton from "./DodCustomAddButton";
import DodAddUserForm from "./DodAddUserForm.vue";
import CustomButton from "../CustomButton.vue";
import DodCustomDateInput from "./DodCustomDateInput.vue";
import PrimaryInput from "../PrimaryInput.vue";
import CustomSelect from "../CustomSelect";
import DodCustomTextarea from "./DodCustomTextarea.vue";
import DodDuplicateFoundModal from "./DodDuplicateFoundModal.vue";
export default {
  components: {
    DodBorderSection,
    DodCustomAddButton,
    DodAddUserForm,
    CustomButton,
    DodCustomDateInput,
    PrimaryInput,
    CustomSelect,
    DodCustomTextarea,
    DodDuplicateFoundModal,
  },
  props: ["pickedDepartment", "customer"],
  emits: ["departmentAction"],
  data() {
    return {
      customerData: {},
      clientData: {},
      duplicate: null,
      isClientDataActive: false,
      startDate: "",
      endDate: "",
      careOption: "",
      price: "",
      isNonStandardRange: false,
      nonStandardRangeText: "",
      contact: "",
      fileInput: [],
      filesToDelete: [],
      filesFetchedFromCustomer: [],
      loading: false,
      isError: false,
      errorsObject: {},
    };
  },
  methods: {
    // Przy dodawaniu zawsze sprawdzamy; przy edycji tylko gdy imię, nazwisko lub telefon
    // faktycznie się zmieniły. Telefon porównujemy po samych cyfrach - tak jak backend.
    isIdentityChanged(data) {
      if (!this.customer) {
        return true;
      }
      const name = (value) => (value || "").replace(/\s+/g, "");
      const digits = (value) => (value || "").replace(/\D/g, "").slice(-9);
      return (
        name(data.firstName) !== name(this.customer.firstName) ||
        name(data.lastName) !== name(this.customer.lastName) ||
        digits(data.phone) !== digits(this.customer.phone)
      );
    },
    // Nowa karta, żeby wpisane w formularzu dane nie przepadły - użytkownik może
    // porównać osoby i wrócić do dodawania.
    openDuplicateProfile() {
      const route = this.$router.resolve({
        name: "DodCustomerDetails",
        params: { id: this.duplicate.id },
      });
      window.open(route.href, "_blank");
    },
    handleAddFile(e) {
      e.target.files.forEach((file) => this.fileInput.push(file));
    },
    handleRemoveExistingFile(event, file) {
      event.preventDefault();
      this.filesToDelete.push(file);
    },
    handleRemoveFile(event, name) {
      event.preventDefault();
      this.fileInput = this.fileInput.filter((e) => e.name !== name);
    },
    handleCheckErrorsObject(key, errorMsg, isTrue) {
      if (isTrue) {
        this.errorsObject = { ...this.errorsObject, [`${key}`]: errorMsg };
        this.isError = true;
      } else {
        this.errorsObject = { ...this.errorsObject, [`${key}`]: "" };
      }
    },

    async onSubmit() {
      try {
        this.loading = true;
        this.isError = false;

        const fileIds =
          this.fileInput && this.fileInput?.length
            ? await Promise.all(
                this.fileInput.map((file) =>
                  this.$store.dispatch("addDodFile", {
                    file,
                  })
                )
              )
            : null;
        const {
          name,
          surname,
          phone,
          city,
          street,
          buildingNumber,
          houseNumber,
          postalCode,
          socialWorkerPhone,
          region,
          lat,
          lng,
        } = this.customerData;
        const data = {
          firstName: name,
          lastName: surname,
          phone: phone,
          city: city,
          street: street,
          streetNumber: buildingNumber,
          houseNumber: houseNumber,
          longitude: lat || null,
          latitude: lng || null,
          postalCode,
          socialWorkerPhone: socialWorkerPhone || "",
          region: region || "",
          departmentId: this.pickedDepartment,
          clientFirstName: this.clientData.name,
          clientLastName: this.clientData.surname,
          clientPhone: this.clientData.phone,
          clientEmail: this.clientData.clientEmail,
          clientCity: this.clientData.city,
          clientStreet: this.clientData.street,
          clientStreetNumber: this.clientData.buildingNumber,
          clientHouseNumber: this.clientData.houseNumber,
          clientPostalCode: this.clientData.postalCode,
          careStartDate: this.startDate,
          careEndDate: this.endDate,
          payment: Number(this.price),
          scopesOfCareIds: [...this.careOption],
          note: this.nonStandardRangeText,
          contactNote: this.contact,
          files:
            fileIds && fileIds.length
              ? [
                  ...fileIds.map((file) => ({
                    fileId: file,
                  })),
                ]
              : [],
        };

        this.handleCheckErrorsObject(
          "firstName",
          "Podaj imię",
          !data.firstName
        );
        this.handleCheckErrorsObject(
          "lastName",
          "Podaj nazwisko",
          !data.lastName
        );
        this.handleCheckErrorsObject(
          "phone",
          "Podaj numer telefonu w formacie 9 cyfr",
          !/^\d{9}$/.test(data.phone)
        );
        this.handleCheckErrorsObject(
          "socialWorkerPhone",
          "Numer telefonu musi mieć 9 cyfr",
          !!data.socialWorkerPhone && !/^\d{9}$/.test(data.socialWorkerPhone)
        );
        this.handleCheckErrorsObject("city", "Podaj miejscowość", !data.city);
        this.handleCheckErrorsObject(
          "streetNumber",
          "Podaj nr budnyku",
          !data.streetNumber
        );
        this.handleCheckErrorsObject(
          "clientFirstName",
          "Podaj imię",
          !data.clientFirstName && this.isClientDataActive
        );
        this.handleCheckErrorsObject(
          "clientLastName",
          "Podaj nazwisko",
          !data.clientLastName && this.isClientDataActive
        );
        this.handleCheckErrorsObject(
          "clientPhone",
          "Podaj numer telefonu w formacie 9 cyfr",
          this.isClientDataActive && !/^\d{9}$/.test(data.clientPhone)
        );
        this.handleCheckErrorsObject(
          "clientCity",
          "Podaj miejscowość",
          !data.clientCity && this.isClientDataActive
        );

        this.handleCheckErrorsObject(
          "clientStreetNumber",
          "Podaj nr budynku",
          !data.clientStreetNumber && this.isClientDataActive
        );
        this.handleCheckErrorsObject("region", "Podaj rejon", !data.region);
        this.handleCheckErrorsObject(
          "careStartDate",
          "Podaj datę startu opieki",
          !data.careStartDate
        );
        if (!this.pickedDepartment) {
          this.isError = true;
          this.$emit("departmentAction", true);
        } else {
          this.$emit("departmentAction", false);
        }
        if (!this.isError) {
          // Duplikat blokujemy tak samo przy dodawaniu, jak przy edycji - inaczej blokadę
          // da się obejść, zapisując osobę pod innymi danymi i podmieniając je zaraz potem.
          // Przy edycji sprawdzamy tylko, gdy dane identyfikujące się zmieniają (w bazie są
          // zdublowane rekordy sprzed tej zmiany - ich edycja musi dalej działać).
          if (this.isIdentityChanged(data)) {
            const existing = await this.$store.dispatch(
              "checkCustomerDuplicate",
              {
                firstName: data.firstName,
                lastName: data.lastName,
                phone: data.phone,
                excludeId: this.customer ? this.customer.id : undefined,
              }
            );
            if (existing) {
              this.duplicate = existing;
              return;
            }
          }
          if (this.customer) {
            await Promise.all(
              this.filesToDelete.map((file) =>
                this.$store.dispatch("removeDodFile", file.id)
              )
            );
            const response = await this.$store.dispatch("editDodCustomer", {
              customerId: this.customer.id,
              data,
            });
            if (response) {
              this.$notify({
                group: "success",
                text: "Podopieczny został zedytowany pomyślnie",
              });
              this.$router.push({
                name: "DodCustomerDetails",
                params: {
                  id: this.customer.id,
                },
              });
              if (this.customerStatuses && this.customerStatuses.length > 0) {
                this.$store.dispatch(
                  "setSelectedCustomerStatus",
                  this.customerStatuses[0]
                );
              }
            } else {
              throw response;
            }
          } else {
            const response = await this.$store.dispatch("addCustomer", data);
            if (response) {
              this.$notify({
                group: "success",
                text: "Podopieczny został dodany pomyślnie",
              });
              this.$router.push({
                name: "Customers",
                query:
                  this.customerStatuses && this.customerStatuses.length > 0
                    ? { status: this.customerStatuses[0].id }
                    : {},
              });
              if (this.customerStatuses && this.customerStatuses.length > 0) {
                this.$store.dispatch(
                  "setSelectedCustomerStatus",
                  this.customerStatuses[0]
                );
              }
            } else {
              throw response;
            }
          }
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się dodać podopiecznego",
        });
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    if (this.customer) {
      this.customerData.name = this.customer.firstName || "";
      this.customerData.surname = this.customer.lastName || "";
      this.customerData.phone = this.customer.phone || "";
      this.customerData.city = this.customer.city || "";
      this.customerData.street = this.customer.street || "";
      this.customerData.buildingNumber = this.customer.streetNumber || "";
      this.customerData.houseNumber = this.customer.houseNumber || "";
      this.customerData.postalCode = this.customer.postalCode || "";
      this.customerData.socialWorkerPhone =
        this.customer.socialWorkerPhone || "";
      this.customerData.region = this.customer.region || "";
      if (this.customer.clientFirstName) {
        this.isClientDataActive = true;
        this.clientData.name = this.customer.clientFirstName || "";
        this.clientData.surname = this.customer.clientLastName || "";
        this.clientData.phone = this.customer.clientPhone || "";
        this.clientData.city = this.customer.clientCity || "";
        this.clientData.street = this.customer.clientStreet || "";
        this.clientData.buildingNumber = this.customer.clientStreetNumber || "";
        this.clientData.houseNumber = this.customer.clientHouseNumber || "";
        this.clientData.postalCode = this.customer.clientPostalCode || "";
        this.clientData.clientEmail = this.customer.clientEmail || "";
      }
      this.startDate = this.customer.careStartDate || "";
      this.endDate = this.customer.careEndDate || "";
      this.careOption = this.customer.scopesOfCare
        ? this.customer.scopesOfCare.map((e) => e.id)
        : [];
      this.price = this.customer.payments?.length
        ? this.customer.payments?.at(this.customer.payments.length - 1).amount
        : "";
      if (this.customer.note) {
        this.isNonStandardRange = true;
        this.nonStandardRangeText = this.customer.note || "";
      }
      this.contact = this.customer.contactNote || "";
      this.filesFetchedFromCustomer = this.customer.attachments || [];
    }
  },

  computed: {
    scopesOfCares() {
      const scopes = this.$store.getters.getDodScopesOfCare;
      if (scopes && scopes.data) {
        return scopes.data.map((s) => {
          return {
            name: s.name,
            value: s.id,
            shortName: s.name,
          };
        });
      } else {
        return [];
      }
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
  },
};
</script>

<style scoped>
.input-label {
  color: #090741;
  font-weight: 700;
  font-size: 12px;
  padding-left: 5px;
  margin-bottom: 0;
  margin-top: 5px;
}
.dashed-square {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  border: 1px dashed #c1c1cf;
  cursor: pointer;
  width: fit-content;
  margin-left: 10px;
}
.remove-file {
  color: red;
  cursor: pointer;
}
</style>
